import { render, staticRenderFns } from "./Editblog.vue?vue&type=template&id=64463296&"
import script from "./Editblog.vue?vue&type=script&lang=js&"
export * from "./Editblog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports